import { KeyValueFormulaFieldModel, KeyValueIsDisabledModel } from '@models/common';
import {
  DisplayType,
  FieldOrigin,
  FieldTypeEnum,
  KeyValueFormattingModel,
  KeyValueRestrictionModel,
} from '@models/module/fields/enums';
import { Currency } from '@models/system';

export interface DetailScreenFieldModel {
  Id?: number;
  Name?: string;
  Label?: string;
  HasMultipleValues: boolean;
  TypeId?: number;
  Type: FieldTypeEnum;
  DisplayTypeId?: number;
  DisplayType: DisplayType;
  Restrictions: KeyValueRestrictionModel[];
  Formattings: KeyValueFormattingModel[];
  IsSystem: boolean;
  IsMandatory: boolean;
  DataSourceId?: number;
  Expression?: string;
  ExpressionFields?: KeyValueFormulaFieldModel<string>[];
  Pattern?: string;
  InUse: boolean;
  ParentChildLinkId?: number;
  FieldOrigin: FieldOrigin;
  DefaultValue?: any;
  MultipleDefaultValue: any[];
  EntityIds: number[];
  X: number;
  Y: number;
  Cols: number;
  Rows: number;
  Annotation?: string;
  Currency: Currency;
  RelationId?: number;
  ComplexFormulaId?: number;
  TriggeredFields: number[];
  SystemFieldName?: string;
  Value?: any;
  OldValue?: any;
  AggregateValue?: any;
  AggregateOldValue?: any;
  DataSources: KeyValueIsDisabledModel<number, string>[];
  ParentFieldId?: number;
  ParentFieldIds: number[];
  ParentFieldDataSourceId?: number;
  ParentDataSourceName?: string;
  IsParent: boolean;
  ParentHasDefaultValue: boolean;
  ChildFieldIds: number[];
  IsFilter: boolean;
  CurrentDateTime: boolean;
  UsedOnWeather?: boolean;
  WeatherDateId?: number;
  WeatherLocationId?: number;
  ActionInstanceId?: number;
  PreviousActionInstanceId?: number;
  ScreensId: number[];
}
